// extracted by mini-css-extract-plugin
module.exports = {"trustPilotReview":"TrustPilotReview_trustPilotReview__emwSe","reviews":"TrustPilotReview_reviews__2stJ5"};